// extracted by mini-css-extract-plugin
export var bgImage = "styles-module--bgImage--9d478";
export var columnImage = "styles-module--columnImage--e28c2";
export var darkRow = "styles-module--darkRow--d5834";
export var lightRow = "styles-module--lightRow--dc64a";
export var showcaseSection = "styles-module--showcaseSection--890e4";